import {Component, EventEmitter, Input, Output, OnInit, inject} from '@angular/core';
import {CurrencySymbolPipe} from "../../../shared/pipes/currency-symbol.pipe";
import {DividerModule} from "primeng/divider";
import {InputSwitchModule} from "primeng/inputswitch";
import {DecimalPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {OrderDetails} from "../../model/OrderDetails";
import {Subscriptions} from "../../model/subscriptions.models";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {APP_CONFIG} from "../../../app-config";

@Component({
    selector: 'app-plan-selection',
    standalone: true,
    imports: [
        CurrencySymbolPipe,
        DividerModule,
        InputSwitchModule,
        NgForOf,
        NgIf,
        FormsModule,
        NgClass,
        TranslatePipe,
        DecimalPipe
    ],
    templateUrl: './plan-selection.component.html',
    styleUrl: './plan-selection.component.scss'
})
export class PlanSelectionComponent implements OnInit {
    appConfig = inject(APP_CONFIG);

    @Input() packages!: OrderDetails[];
    @Input() isYearly!: boolean;
    @Input() isAutoRouted!: boolean;
    @Input() userSubscription!: Subscriptions;
    @Input() selectedPackage!: OrderDetails;

    @Output() packageSelected = new EventEmitter();


    constructor(translate: TranslateService) {
    }

    ngOnInit() {
        //console.log(this.selectedPackage);



    }

    changeSelectedPackage(index: number) {

        let selectedPackage = this.packages[index];
        selectedPackage.isYearly = this.isYearly;

        this.packageSelected.emit(selectedPackage)
    }
}
